// Types
import type { useParams, usePathname } from 'next/navigation';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// Lib
import { layoutHeaderDisabled } from '@/lib/layout/layoutHeaderDisabled';

type GetIsHeaderManageProfilesDisabledProps = {
    pathname: ReturnType<typeof usePathname>;
    params: ReturnType<typeof useParams>;
};

export function getIsHeaderManageProfilesDisabled({
    pathname,
    params = {}
}: GetIsHeaderManageProfilesDisabledProps) {
    const urlsFormatted = formatUrls(layoutHeaderDisabled, params);
    return urlsFormatted.includes(pathname);
}
